export class ReportPatientStatementParamsModel {
  ProvidersId: string[];
  PracticeId: number;
  PracticeLocations: string[];
  initialDate: Date;
  endDate: Date;
  isProvider: boolean;
  isPractice: boolean;
  statementNote: string;
}

export class ReportTransactionParamsModel{
  ProvidersId: string[];
  PracticeId: number;
  PracticeLocations: string[];
  initialDate: Date;
  endDate: Date;
  isProvider: boolean;
  isPractice: boolean;
  transactionType: string;
}

export class ReportVoidedTransactionParamsModel{
  ProvidersId: string[];
  PracticeId: number;
  PracticeLocations: string[];
  initialDate: Date;
  endDate: Date;
  isProvider: boolean;
  isPractice: boolean;
  isOrderByDateCharged: boolean;
}

export class ReportLedgerTransactionParamsModel{
  ProvidersId: string[];
  PracticeId: number;
  PracticeLocations: string[];
  initialDate: Date;
  endDate: Date;
  isProvider: boolean;
  isPractice: boolean;
  showProductionReport: boolean;
  showReceiptReport: boolean;
  showActivityReport: boolean;
  isActivityGroupByDoctor: boolean;
  showBankDepositsReport: boolean;
  showTransactionsReport: boolean;
  showTransactionCash: boolean;
  showTransactionCheck: boolean;
  showTransactionCreditCard: boolean;
  showTransactionDebit: boolean;
  showTransactionOther: boolean;
  isNewPage: boolean;
}

export class ReportFinancialAuditParamsModel{
  initialDate: Date;
  endDate: Date;
  PracticeId: number;
}

export class ReportListOfAppointmentsParamsModel{
  initialDate: Date;
  endDate: Date;
  PracticeId: number;
  PracticeLocations: string[];
  ProvidersId: string[];
  isProvider: boolean;
  isPractice: boolean;
}

export class ReportCreditBalanceParamsModel{
  PracticeId: number;
  PracticeLocations: string[];
  ProvidersId: string[];
  isProvider: boolean;
  isPractice: boolean;
}

export class ReportCreditCardReceiptParamsModel{
  PaymentId: string;
  PatientId: string;
  LedgerId: string;
}

export class ReportRecallParamsModel{
  initialDate: Date;
  endDate: Date;
  PracticeId: number;
  PracticeLocations: string[];
  ProvidersId: string[];
  isProvider: boolean;
  isPractice: boolean;
}

export class ReportOutstandigClaimsModel {
  isEClaims: boolean;
	isADAForm: boolean;
	Over30: boolean;
	Over60: boolean;
	Over90: boolean;
  PracticeId: number;
  PracticeLocations: string[];
  ProvidersId: string[];
  isProvider: boolean;
  isPractice: boolean;
  }

  export class ReportFeeCalculationReportParamsModel {
    isOrderedByDate: boolean;
    isOrderedByToothCode: boolean;
  }
  export class ReportBankDepositsParamsModel {
    isCash: boolean;
    isCheck: boolean;
    isCashandCheck: boolean;
  }
  export class ReportReferringAnalysisModel {
    isProvider: boolean;
    isPractice: boolean;
    PracticeLocations: string[];
    ProvidersId: string[];
    initialDate: Date;
    endDate: Date;
    isAll: boolean;
    IncludePerDoctor: boolean;
    IncludePerCode: boolean;
    IncludeBreakDown: boolean;

  }
  export class ReportPatientsNeedAppointmentParamsModel {
    PracticeLocations: string[];
    initialDate: Date;
    endDate: Date;
    isNewOnly: boolean;
  }

